import * as React from 'react'
import {TableCell} from "@mui/material";
import { PricingSkuInfoBlock } from 'Pages/Pricing/@components';


export default function PricingSkuCell({ sku, category, brand, ean }) {
	return <TableCell>
		<PricingSkuInfoBlock sku={sku} category={category} brand={brand} ean={ean} />
	</TableCell>
}